export default __webpack_public_path__ + "static/media/telegramLogo.be6948c6.webp";